import moment from 'moment';

export const toHumanReadableDate = date => {
  return moment(date).format('YYYY/MM/DD');
};

export const formatDate = date => {
  return moment(date).utcOffset(0, true).format('yyyy-MM-DD');
};

export const addDays = (date, days) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

export const getToday = () => {
  return new Date();
};

export const getFirstDayOfTheWeek = date => {
  return moment(date).startOf('week').toDate();
};

export const getLastDayOfTheWeek = date => {
  return moment(date).endOf('week').toDate();
};

export const getFirstAvailableDate = (firstDayOfWeek, excludedDateIntervals) => {
  let firstAvailableDate = firstDayOfWeek;

  while (isDateWithinIntervals(firstAvailableDate, excludedDateIntervals)) {
    firstAvailableDate = moment(firstAvailableDate).add(1, 'week');
  }

  return firstAvailableDate;
};

export const isDateWithinIntervals = (date, dateIntervals) =>
  dateIntervals.some(
    ({ start, end }) => moment(date).isSameOrAfter(start) && moment(date).isSameOrBefore(end)
  );
